import React from "react"
import Expansion from "components/Expansion";
import styles from "./style.js"
import { withStyles } from '@material-ui/core';
import Button from 'storybookComponents/Button';
import Field from "./multiTagField";
import { Formik, Form } from "formik";
import Icon from "storybookComponents/Icon";
import Typography from "storybookComponents/Typography";
import * as apis from "relay/invite";
import { Invitees } from "./scheduleForm";
import SelectDate, { parseDate } from "./selectDate";
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import * as path from "constants/path";
import UserContext from 'context/UserContext';


const ScheduleForm = ({ expanded, handleExpandedPanel, id, onChange, ...props }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  React.useEffect(() => {
    let payload = {
      inviteScheduleAt: props.values.inviteScheduleAt,
      //invitedGroups: props.values.invitedGroups.length ? props.values.invitedGroups.toString() : "",
      id
    }
    onChange(payload)

  }, [props.values])

  return (
    <Form>
      <Invitees
        expanded={expanded === "Second"}
        name="Second"
        handleExpandedPanel={handleExpandedPanel}
        propertyId={subOrgDetails.id}
        {...props}
      />
    </Form>
  )
}


const SentMessage = ({ classes }) => <div className={classes.flexBox}><Icon type=" icon-n-check" className={classes.sentSuccess} />&nbsp;<Typography type="body1">Sent successfully</Typography>&nbsp;</div>

const ScheduleEvent = ({ classes, setTitle, title, id, showNotification, onChange, inviteScheduledAt, invitedGroups, subject, lastTestEmails, lastTestPhones, emailSms, image, shortEnrollUrl, propertyName, onScheduleSMSEmail, getSubmitButtonState, username, ...props }) => {

  const [sendingTest, setSendingTest] = React.useState(false);
  const [testEmailSent, setTestEmailSent] = React.useState(props.residentInviteCampaignTested);
  const [expanded, setExpanded] = React.useState((inviteScheduledAt || props.residentInviteCampaignTested) ? "Second" : "First");
  const prevDate = inviteScheduledAt ? new Date(inviteScheduledAt) : "";
  React.useEffect(() => {
    setTitle([
      { "label": "Referral Campaigns", "link": path.getAppPath(), "active_state": false }, { "label": title, "link": "#", "active_state": false },
    ])
  }, [])
  const handleExpandedPanel = (panel) => {
    if (panel === expanded)
      setExpanded("");
    else
      setExpanded(panel);
  };

  const onSend = async (data) => {
    try {
      setSendingTest(true)
      let recipients = [...data.emails, ...data.phones].toString()
      let payload = {
        id,
        recipients,
        bodyHtml: "auto",
        bodyPlain: emailSms + "\n\nEnroll Now\n" + shortEnrollUrl + "\n\nBest Regards\n" + propertyName,
        subject
      }
      await apis.testInvite(payload)
      setSendingTest(false)
      setTestEmailSent(true)
      const uncachebleError = getErrorMessage(checkUncatchableError("testInviteMutation"));
      if (uncachebleError) {
        showNotification(uncachebleError, "error");
      } else {
        setExpanded("Second")
      }
    }
    catch (error) {
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
      setSendingTest(false)
    }

  }

  const renderTestForm = (props) => {
    return (
      <Form>
        <Expansion
          expanded={expanded === "First"}
          name="First"
          handleExpandedPanel={handleExpandedPanel}
          defaultOpen={!inviteScheduledAt}
          headerIcon={open => testEmailSent && open ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null}
          header="Send Test Invite"
          subtitle="Add your email(s) and phone number(s) below to test the referral campaign invites before publishing them"
          rightSection={open =>
            testEmailSent && !open ? <SentMessage classes={classes} /> : null
          }
        >
          <div className={classes.testForm}>
            <Field {...props} keyName="emails" label="Email(s)" description="Press ‘Enter’ or ‘Comma’ to enter multiple emails" />
            <Field {...props} regex={/^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/} mask="XXX-XXX-XXXX" restrictText keyName="phones" label="Phone Number(s)" description="Press ‘Enter’ or ‘Comma’ to enter multiple phone numbers" />
            <Button
              color="hylyBlue"
              onClick={props.handleSubmit}
              variant="primary" size="md"
              className={classes.sendButtonStyle}
              state={sendingTest || (!props.values.emails.length && !props.values.phones.length) ? "inactive" : "active"}
            >
              {testEmailSent ? "Resend Test Invite" : "Send Test Invite"}
            </Button>
          </div>
        </Expansion>
      </Form>
    )
  }

  const renderScheduleForm = (props) => {
    return <ScheduleForm {...props} getSubmitButtonState={getSubmitButtonState} onScheduleSMSEmail={onScheduleSMSEmail} expanded={expanded} handleExpandedPanel={handleExpandedPanel} onChange={onChange} id={id} prevDate={prevDate} invitedGroups={invitedGroups} />
  }


  return (
    <div className={classes.rootContainer}>
      <div className={classes.fieldContainer}>
        <Formik initialValues={{
          emails: lastTestEmails || [username],
          phones: lastTestPhones || []
        }}
          onSubmit={onSend}
        >
          {renderTestForm}

        </Formik>
      </div>
      <div className={`${testEmailSent ? "" : classes.disabledStyle}`}>
        <Formik
          initialValues={{
            invitedGroups: [],
            inviteScheduleAt: ""
          }}
        >
          {renderScheduleForm}
        </Formik>
      </div>


    </div>


  )
}

export default (withStyles)(styles)(ScheduleEvent);